
<div class="val-mes-abonnements val-flex-conteneur val-flex-colonne">
  <div class="val-mes-abonnements-titre">{{ Texte("titre", "Mes abonnements") }}</div>

  <val-panneau-information>
    <p>{{ Texte("explication", "Choisissez les événements dont vous souhaitez être averti, et sur quels canaux : par e-mail à l’adresse de votre compte, ou dans Teams via l’URL d’un workflow.") }}</p>
  </val-panneau-information>

  @if (message)
  {
    <div class="val-mes-abonnements-message val-flex-conteneur"
         [class.val-mes-abonnements-message-erreur]="message.erreur">
      <val-fonte-icone [iconeCss]="message.erreur ? 'fas fa-exclamation-triangle' : 'fas fa-check-circle'"></val-fonte-icone>
      <div class="val-mes-abonnements-message-texte val-flex-1">{{ message.texte }}</div>
      <button kendoButton
              type="button"
              fillMode="flat"
              class="val-mes-abonnements-message-fermer"
              iconClass="fas fa-times"
              [title]="Texte('fermer', 'Fermer')"
              (click)="FermerMessage()">
      </button>
    </div>
  }

  @if (chargementEnCours)
  {
    <div class="val-mes-abonnements-chargement">{{ Texte("chargement", "Chargement des abonnements…") }}</div>
  }
  @else if (erreurChargement)
  {
    <div class="val-mes-abonnements-erreur-chargement">{{ Texte("erreur.chargement", "Les abonnements n’ont pas pu être chargés. Réessayez plus tard.") }}</div>
  }
  @else if (lignes.length === 0)
  {
    <div class="val-mes-abonnements-aucun-type">{{ Texte("aucun-type", "Aucun événement ne vous est proposé.") }}</div>
  }
  @else
  {
    <div class="val-mes-abonnements-email val-flex-conteneur">
      <span class="val-mes-abonnements-email-libelle">{{ Texte("adresse-email", "Adresse e-mail du compte") }}</span>
      @if (EmailDisponible)
      {
        <span class="val-mes-abonnements-email-adresse">{{ adresseEmail }}</span>
      }
      @else
      {
        <span class="val-mes-abonnements-email-absente">{{ Texte("email-absent", "Votre compte n’a pas d’adresse e-mail : l’abonnement par e-mail n’est pas disponible.") }}</span>
      }
    </div>

    @for (ligne of lignes; track ligne.type.code)
    {
      <div class="val-mes-abonnements-type val-flex-conteneur val-flex-colonne"
           [attr.data-code]="ligne.type.code">
        <div class="val-mes-abonnements-type-libelle">{{ LibelleType(ligne.type) }}</div>

        <div class="val-mes-abonnements-canal val-mes-abonnements-canal-email val-flex-conteneur">
          <kendo-checkbox class="val-kd-check-box val-mes-abonnements-case-email"
                          [checkedState]="!!ligne.abonnementEmail"
                          [disabled]="!EmailDisponible || ligne.operationEnCours"
                          (checkedStateChange)="ChangerEmail(ligne, $event === true)">
          </kendo-checkbox>
          <span class="val-mes-abonnements-canal-libelle">{{ Texte("canal.email", "Par e-mail") }}</span>
        </div>

        <div class="val-mes-abonnements-canal val-mes-abonnements-canal-teams val-flex-conteneur">
          <span class="val-mes-abonnements-canal-libelle">{{ Texte("canal.teams", "Dans Teams") }}</span>

          @if (ligne.TeamsConfigure)
          {
            <span class="val-mes-abonnements-teams-configure">
              <val-fonte-icone iconeCss="fas fa-check"></val-fonte-icone>
              {{ Texte("teams.configure", "URL de workflow configurée") }}
            </span>
          }

          @if (ligne.SaisieUrlTeamsVisible)
          {
            <kendo-textbox class="val-kd-texte-editeur val-mes-abonnements-url-teams val-flex-1"
                           [placeholder]="Texte('teams.placeholder', 'https://… (URL du workflow Teams)')"
                           [value]="ligne.urlTeams"
                           [disabled]="ligne.operationEnCours"
                           (valueChange)="ligne.urlTeams = $event">
            </kendo-textbox>
          }
          @else
          {
            <div class="val-flex-1"></div>
          }

          <div class="val-mes-abonnements-commandes-teams val-flex-conteneur">
            <val-simple-bouton class="val-mes-abonnements-tester-teams"
                               [libelle]="Texte('teams.tester', 'Envoyer un message de test')"
                               [desactive]="ligne.operationEnCours || (!UrlTeamsSaisie(ligne) && !ligne.TeamsConfigure)"
                               (boutonClick)="TesterTeams(ligne)">
            </val-simple-bouton>

            @if (ligne.SaisieUrlTeamsVisible)
            {
              <val-simple-bouton class="val-mes-abonnements-enregistrer-teams"
                                 [libelle]="Texte('teams.enregistrer', 'Enregistrer')"
                                 [desactive]="ligne.operationEnCours || !UrlTeamsSaisie(ligne)"
                                 (boutonClick)="EnregistrerTeams(ligne)">
              </val-simple-bouton>
              @if (ligne.remplacementUrlTeams)
              {
                <val-simple-bouton class="val-mes-abonnements-annuler-teams"
                                   [libelle]="Texte('teams.annuler', 'Annuler')"
                                   [desactive]="ligne.operationEnCours"
                                   (boutonClick)="AnnulerRemplacementTeams(ligne)">
                </val-simple-bouton>
              }
            }
            @else
            {
              <val-simple-bouton class="val-mes-abonnements-remplacer-teams"
                                 [libelle]="Texte('teams.remplacer', 'Remplacer l’URL')"
                                 [desactive]="ligne.operationEnCours"
                                 (boutonClick)="RemplacerTeams(ligne)">
              </val-simple-bouton>
            }

            @if (ligne.abonnementTeams)
            {
              <val-simple-bouton class="val-mes-abonnements-desabonner-teams"
                                 [libelle]="Texte('teams.desabonner', 'Se désabonner')"
                                 [desactive]="ligne.operationEnCours"
                                 (boutonClick)="DesabonnerTeams(ligne)">
              </val-simple-bouton>
            }
          </div>
        </div>
      </div>
    }
  }
</div>
